import http from '@/axios/http'
import { getuser_id } from "@/localStorage/localStorage";

//告警配置列表
export function showAlarmConfig() {
    const data = {
        user_id: getuser_id(),
        offset: 1,
        limit: 10
    }
    return http({
        url: '/api/alarm/showAlarmConfig',
        method: 'post',
        data
    })
}

//添加告警
export function addAlarmConfig({ wtAid, wtName, wtLevel, wtWay, wtExp }) {
    const data = {
        user_id: getuser_id(),
        wtAid: wtAid,
        wtName: wtName,
        wtLevel: wtLevel,
        wtWay: wtWay,
        wtExp: wtExp
    }
    return http({
        url: '/api/alarm/addAlarmConfig',
        method: 'post',
        data
    })
}

//修改告警
export function modifyAlarmConfig({ wtRole, wtId, wtAid, wtName, wtLevel, wtWay, wtExp }) {
    if (wtLevel == '紧急') {
        wtLevel = 1
    } else if (wtLevel == '主要') {
        wtLevel = 2
    } else if (wtLevel == '次要') {
        wtLevel = 3
    } else if (wtLevel == '警告') {
        wtLevel = 4
    } else if (wtLevel == '不确定') {
        wtLevel = 5
    }
    const data = {
        user_id: getuser_id(),
        wtRole: wtRole,
        wtId: wtId,
        wtAid: wtAid,
        wtName: wtName,
        wtLevel: wtLevel,
        wtWay: wtWay,
        wtExp: wtExp
    }
    return http({
        url: '/api/alarm/modifyAlarmConfig',
        method: 'post',
        data
    })
}

//删除告警
export function deleteAlarmConfig({ wtRole, wtId }) {
    const data = {
        user_id: getuser_id(),
        wtRole: wtRole,
        wtId: wtId
    }
    return http({
        url: '/api/alarm/deleteAlarmConfig',
        method: 'post',
        data
    })
}
//查询排序

export function queryKeyword(keyword, offset, limit, sort) {
    const data = {
        user_id: getuser_id(),
        keyword: keyword,
        offset: offset,
        limit: limit,
        wtAid: sort.wtAid,
        wtName: sort.wtName,
        wtLevel: sort.wtLevel,
        wtWay: sort.wtWay,
        wtExp: sort.wtExp,
        wtCreate: sort.wtCreate
    }
    return http({
        url: '/api/alarm/queryKeyword',
        method: 'post',
        data
    })
}